<template>
  <!-- TODO: ADD PAGINATION HERE, TOO MANY EMPS! -->
  <fragment>
    <v-data-table ref="expandableTable" :height="tableHeight" v-if="emps" :headers="tableHeadersToShow"
      :items="empsToShow" sort-by="name" :search="search" item-key="_id" dense :group-by="initGroups || groupBy"
      no-data-text="No hay resultados" no-result-text="No hay resultados" fixed-header hide-default-footer
      :page="pagination.page" :items-per-page="empsPerPage"
      @click:row="$router.push(`/dashboard/employee/${$event._id}`)">
      <template v-slot:top>
        <v-toolbar height="initial" flat color="white">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                hide-details></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" class="text-center d-flex flex-column align-start pl-sm-10">
              <v-switch dense hide-details :input-value="!!groupBy" @change="setGroup"
                label="Por Departamento"></v-switch>
              <v-switch dense hide-details :input-value="!!showInactiveEmps" @change="setShowInactive" label="Baja">
              </v-switch>
            </v-col>
            <v-col cols="3" sm="2" class="px-0 pt-sm-5 text-center">
              <v-btn :loading="isFetching" :disabled="isFetching || !empsToShow" color="primary" class="white--text"
                @click="downloadEmpSheet">
                <v-icon left dark>mdi-cloud-download</v-icon>Bajar
              </v-btn>
            </v-col>
            <v-col cols="3" sm="1" class="text-center px-0 pt-sm-5">
              <v-btn color="primary" class="mb-2" @click="$router.push('/dashboard/employee/edit')">
                <v-icon>person_add</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:item.health="{ item }">{{
        item.health ? "Si" : "No"
      }}</template>

      <template v-slot:group.header="props">
        <td colspan="6" @click="props.toggle()">
          <v-btn class="ma-0 v-btn--round" icon small color="primary">
            <v-icon dark>mdi-minus</v-icon>
          </v-btn>
          <span class="ml-2 font-weight-bold">{{ props.group }}</span>
        </td>
      </template>
      <template v-slot:header.cId="props" class="py-0">
        <span style>
          <v-btn v-if="groupBy" class="ma-0 v-btn--round" icon small color="primary"
            @click.stop="collapseAll(isCollapsed)">
            <v-icon dark>mdi-minus</v-icon>
          </v-btn>Codigo
        </span>
      </template>
      <template v-slot:item.entry="{ item }">{{
        item.entry ? new Date(item.entry).toLocaleDateString("es-GU") : '-'
      }}</template>
      <template v-if="showInactiveEmps" v-slot:item.exit="{ item }">{{
        item.exit ? new Date(item.exit).toLocaleDateString("es-GU") : '-'
      }}</template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2"
          @click.stop="$router.push(`/dashboard/employee/edit/${item._id}`)">mdi-pencil</v-icon>
        <v-icon small @click.stop="deleteItem(item)">mdi-delete</v-icon>
      </template>

      <template v-slot:footer>
        <div class="py-2 px-3">
          <v-pagination v-if="pagination.page" v-model="pagination.page" :length="pageCount"
            total-visible="10"></v-pagination>
          <span class="font-weight-bold">Numero de Empleados:</span>
          <span class="font-weight-medium ml-2">{{ empsToShow.length }}</span>
          <span class="font-weight-bold ml-4">Empleados que han enrollado huellas:</span>
          <span class="font-weight-medium ml-2">{{ empsWithFpCount }}</span>
          <span class="blue--text pointer ml-6" @click="pagination.page ? pagination.page = 0 : pagination.page = 1">{{
            pagination.page ? 'Enseñar Todos' : 'Paginas' }}</span>
        </div>
      </template>
    </v-data-table>
    <router-view />
  </fragment>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { tableHeader } from '@/services/constData.js'
export default {
  async created() {
    await this.loadEmps()
    this.pagination.totalItems = this.empsToShow.length
    this.initGroups = null
    this.pagination.rowsPerPage = this.empsPerPage
    this.groupBy && this.collapseAll(false)
  },
  data: () => ({
    search: '',
    initGroups: 'department',
    isCollapsed: true,
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0
    }
  }),

  methods: {
    ...mapActions(['loadEmps', 'loadFps']),
    downloadEmpSheet() {
      this.$store.dispatch('downloadEmpSheet')
    },
    setGroup(val) {
      this.isCollapsed = false
      this.$router.push({ query: { ...this.$route.query, group: val ? 'department' : '' } })
    },
    async setShowInactive(val) {
      this.$router.push({ query: { ...this.$route.query, baja: val ? 'true' : 'false' } })
    },
    collapseAll(val) {
      this.isCollapsed = !this.isCollapsed
      if (!this.$refs.expandableTable) return false
      Object.keys(this.$refs.expandableTable.openCache).forEach(dep => {
        this.$refs.expandableTable.openCache[dep] = val
      })
    },
    deleteItem(item) {
      confirm('Estás seguro de que quieres eliminar este empleado?') &&
        this.$store.dispatch({ type: 'deleteEmp', empId: item._id })
    },
  },
  computed: {
    ...mapGetters('user', ['loggedinUser']),
    ...mapGetters(['empIdToFpMap', 'emps', 'isFetching']),
    empsPerPage() {
      if (!this.pagination.page) return -1
      return this.$refs.expandableTable ? Math.floor(this.$refs.expandableTable.$el.children[1].clientHeight / 34) : 20
    },
    tableHeadersToShow() {
      const headers = this.loggedinUser.isEditor ? tableHeader.emp :
        tableHeader.emp.filter(header => header.value !== 'actions')
      return this.showInactiveEmps ? headers : headers.filter(head => head.value !== 'exit')
    },
    pageCount() {
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    groupBy() {
      return this.$route.query.group || null
    },
    showInactiveEmps() {
      return this.$route.query.baja === 'true'
    },
    empsToShow() {
      return this.emps.filter(emp => {
        if (this.showInactiveEmps) {
          return emp.exit && new Date(emp.exit) < new Date()
        }
        return !emp.exit || new Date(emp.exit) > new Date()
      })
    },
    empsWithFpCount() {
      return this.empsToShow.filter(emp => emp.fpEnrolledCount).length
    },
    currentEmp() {
      return this.$route.params.id
    },
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600
    },
    tableHeight() {
      const height = this.isMobile ? '225px' : this.pagination.page ? '235px' : '190px'
      return `calc(100vh - ${height})`
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.group) {
        this.collapseAll(false)
      }
    },
    emps() {
      this.pagination.totalItems = this.empsToShow.length
    }
  }
}
</script>
<style></style>